/**
 * preferences handles all the functionality for the preferences tab
 * in the my soul section of the smart profile
 */
SC.preferences = (function () {
  // buttons
  var addInstructorButton = null;
  var cancelButton = null;
  var closeModalButton = null;
  var deleteInstructorButtons = null;
  var deleteAccountButton = null;
  var deleteFormButton = null;
  var cancelDeleteButton = null;
  var doneModalButton = null;
  var mainEditButtons = null;
  var saveButtons = null;
  var primaryStudioSubmitButton = null; // button to temporarily save the primary studio
  var primaryStudioClearButton = null; // button to clear all checked primary studios
  var initialSelectButtons = null; // the 'Select +' button that appears when no primary or favorite is selected
  var favoriteStudiosSubmitButton = null;// button to temporarily save the favorite studio
  var favoriteStudiosClearButton = null; // button to clear the favorite studios
  var favoriteStudiosSelectedButton = null; // button that appears below favorite dropdown indicating selected fav studio
  var originalSelectedFavorites = null; // button that appears for original favorite dropdown indicating selected fav studio

  // dom elements
  var allInstructorsList = null; // container list for modal instructors (ul)
  var allInstructors = null; // collection of li elements ([lis])
  var counterElement = null;
  var deleteAccountModal = null; // modal container for account deletion
  var favInstructorsList = null; // container for favorite instructors (ul)
  var instructorsModal = null; // container for instructors modal
  var modal = null; // main modal container
  var preferencesContainer = null; // main preferences container
  var searchInstructors = null; // input for search
  var favoriteInputs = null; // all the favorite studio input checkboxes
  var primaryInputs = null; // all the favorite studio input checkboxes
  var primarySelectContainer = null; // container that holds the selected studios for primary
  var favoriteSelectContainer = null; // container that holds the selected studios for favorites
  var primaryStudioDropDown = null; // button to toggle the primary dropdown
  var favoriteStudiosDropDown = null; // button to toggle the favorite studios dropdown
  var selectedFavorites = null;
  var allInstructorContainers = null;
  var favoriteInstructors = null;

  // arrays
  var addInstructorIds = []; // array of instructor ids to insert into db
  var originalFavIds; // ids of all the original favorites
  var removeInstructorNodes = []; // array of nodes to remove from favorites main display
  var removeInstructorIds = []; // array of instructor ids to remove from db.
  var originalFavStudios; // array of the original favorite studios
  var addFavStudios; // array of studios to add
  var removeFavStudios = []; // array of studios to unfav

  // flags
  var isModalActive = false;

  // vars
  var activeModal = '';
  var originalPrimaryStudio = null;
  var primaryStudio = {};
  var activeDropDown = null;
  var selectedPrimary = null;

  function init() {
    preferencesContainer = document.getElementById('profile-preferences');
    // exit if we're not on the my_soul page
    if (!preferencesContainer) {
      return;
    }

    // My Studios
    counterElement = document.getElementById('favorite-studio-counter');
    primaryInputs = document.getElementsByClassName('pref__dropdown__primary__input');
    primarySelectContainer = document.getElementById('pref-dropdown-primary-select');
    primaryStudioDropDown = document.getElementById('pref-dropdown-primary-toggle');
    primaryStudioSubmitButton = document.getElementById('pref-dropdown-primary-submit');
    primaryStudioClearButton = document.getElementById('pref-dropdown-primary-clear');
    favoriteSelectContainer = document.getElementById('pref-dropdown-favorites-select');
    favoriteStudiosDropDown = document.getElementById('pref-dropdown-favorites-toggle');
    favoriteInputs = document.getElementsByClassName('pref__dropdown__favorites__input');
    favoriteStudiosSubmitButton = document.getElementById('pref-dropdown-favorite-submit');
    favoriteStudiosClearButton = document.getElementById('pref-dropdown-favorite-clear');
    favoriteStudiosSelectedButton = document.getElementsByClassName('favorite__studios__selected__button');
    originalSelectedFavorites = document.querySelectorAll('.pref__dropdown__favorites__input:checked');
    selectedPrimary = document.querySelector('.pref__dropdown__primary__input:checked');
    originalPrimaryStudio = selectedPrimary;

    // My Instructors
    addInstructorButton = document.getElementById('pref-add-instructor');
    allInstructorsList = document.getElementById('pref-all-instructors');
    allInstructors = allInstructorsList.getElementsByClassName('pref__instructor__item');
    allInstructorContainers = allInstructorsList.getElementsByClassName('pref__favorite__instructor-inner');
    closeModalButton = document.getElementById('pref-close-instructors-modal');
    deleteAccountButton = document.getElementById('handle-preferences-delete');
    deleteAccountModal = document.getElementById('delete-account-modal');
    doneModalButton = document.getElementById('pref-done-instructors-modal');
    favInstructorsList = document.getElementById('pref-fav-instructors');
    favoriteInstructors = document.getElementsByClassName('pref__favorite__instructor');
    instructorsModal = document.getElementById('pref-instructors-modal');
    deleteInstructorButtons = favInstructorsList.getElementsByClassName('pref__favorite__remove-button');
    modal = document.getElementById('preferences-modal');
    cancelDeleteButton = modal.querySelector('#modal-delete-cancel-button');
    deleteFormButton = modal.querySelector('#modal-delete-delete-button');
    mainEditButtons = document.getElementsByClassName('pref__edit');
    saveButtons = document.getElementsByClassName('pref__save');
    searchInstructors = document.getElementById('pref-search-instructors');

    // setup the form for deleting an account
    var input = document.getElementById('delete-account-modal-csrf-token');
    input.value = window.soulcycle.noncePool.pop();

    // Main Profile
    cancelButton = document.getElementById('pref-cancel-edit');
    initialSelectButtons = document.getElementsByClassName('pref__initial__select__button');

    // Document
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentClick);

    getOriginalFavIds();
    getOriginalFavStudios();
    bindListeners();
  }

  /**
   * getOriginalFavIds stores all the original favorite instructor ids in
   * the originalFavIds array
   * @returns {void}
   */
  function getOriginalFavIds() {
    var favInstructors = favInstructorsList.children;

    // ensure we're empty on load
    originalFavIds = [];

    for (var i = 0; i < favInstructors.length - 1; i++) {
      var instructor = favInstructors[i];
      var id = instructor.getAttribute('data-instructor-id');
      originalFavIds.push(id);
    }
  }
  /**
   * getOriginalFavStudios stores all the original favorite and primary studios
   * @returns {void}
   */
  function getOriginalFavStudios() {
    var favStudios = document.querySelectorAll('.pref__dropdown__favorites__input:checked');

    // ensure we're empty on load
    originalFavStudios = [];
    addFavStudios = [];

    for (var i = 0; i < favStudios.length; i++) {
      var studio = favStudios[i];
      var id = studio.value;
      originalFavStudios.push(id);
      addFavStudios.push(id);
    }
  }

  /**
   * bindListeners adds event listeners to all elements that can perform
   * an action
   * @returns {void}
   */
  function bindListeners() {
    addInstructorButton.addEventListener('click', showModal);
    cancelButton.addEventListener('click', cancelEdits);
    cancelDeleteButton.addEventListener('click', closeAndSaveModal);
    closeModalButton.addEventListener('click', closeAndSaveModal);
    deleteAccountButton.addEventListener('click', showModal);
    deleteFormButton.addEventListener('click', closeAndSaveModal);
    doneModalButton.addEventListener('click', closeAndSaveModal);
    searchInstructors.addEventListener('keyup', filterInstructors);
    primaryStudioDropDown.addEventListener('click', toggleDropDown);
    primaryStudioSubmitButton.addEventListener('click', closePrimaryStudioDropDown);
    primaryStudioClearButton.addEventListener('click', clearPrimaryStudioSelection);
    favoriteStudiosDropDown.addEventListener('click', toggleDropDown);
    favoriteStudiosSubmitButton.addEventListener('click', closeFavoriteStudioDropDown);
    favoriteStudiosClearButton.addEventListener('click', clearFavoriteStudioSelection);

    for (var i = 0; i < mainEditButtons.length; i++) {
      mainEditButtons[i].addEventListener('click', handleEdit);
    }

    for (i = 0; i < saveButtons.length; i++) {
      saveButtons[i].addEventListener('click', saveEdits);
    }

    for (i = 0; i < deleteInstructorButtons.length; i++) {
      deleteInstructorButtons[i].addEventListener('click', removeFavInstructor);
    }

    for (i = 0; i < allInstructors.length; i++) {
      allInstructorContainers[i].addEventListener('click', handleModalInstructors);
    }

    for (i = 0; i < initialSelectButtons.length; i++) {
      initialSelectButtons[i].addEventListener('click', handleEdit);
    }

    for (i = 0; i < favoriteInputs.length; i++ ) {
      favoriteInputs[i].addEventListener('change', handleFavoriteStudioInputs);
    }

    for (i = 0; i < favoriteStudiosSelectedButton.length; i++) {
      favoriteStudiosSelectedButton[i].addEventListener('click', uncheckStudio);
    }

    for (i = 0; i < primaryInputs.length; i++) {
      primaryInputs[i].addEventListener('click', checkPrimaryOption);
    }

    for (i = 0; i < favoriteInstructors.length; i++) {
      favoriteInstructors[i].addEventListener('click', handleFavInstructorClick);
    }
  }

  /**
   * checkPrimaryOption acts as a select/deselect on radio inputs.
   * if the current radio is the one being deselected go into clearPrimaryStudioSelection
   * otherwise set current target as the selectedPrimary
   *
   * @param {object} e click event on a primary input
   * @returns {void}
   */
  function checkPrimaryOption(e) {
    var target = e.currentTarget;

    if (target === selectedPrimary) {
      clearPrimaryStudioSelection();
    } else {
      selectedPrimary = target;
    }
  }

  /**
   * cancelEdits removes the edit-mode class from the preferences container
   * and restores any changes that were made.
   * @returns {void}
   */
  function cancelEdits() {
    preferencesContainer.classList.remove('edit-mode');

    // reset nodes that were modified
    resetRemovedNodes();
    resetAddedNodes();
    resetStudios();
  }

  /**
   * resetRemovedNodes readds nodes that were removed during the clsoe fase of the modal
   * and resets any hearts that were unclicked
   * @returns {void}
   */
  function resetRemovedNodes() {
    for (var i = 0; i < removeInstructorNodes.length; i++) {
      var listItem = removeInstructorNodes[i];
      var index = listItem.getAttribute('data-index');
      var id = listItem.getAttribute('data-instructor-id');
      var modalItem = allInstructorsList.querySelector("[data-instructor-id='" + id + "']");
      var heartButton = modalItem.querySelector('.pref__favorite__heart');

      heartButton.classList.add('pref__favorite__heart--faved');
      favInstructorsList.insertBefore(listItem, favInstructorsList.children[index]);
    }

    // reset the removeInstructors arrays to empty
    removeInstructorNodes = [];
    removeInstructorIds = [];
  }

  /**
   * resetAddedNodes removes nodes that were added during the close phase of the modal
   * and resets hearts that were clicked.
   * @returns {void}
   */
  function resetAddedNodes() {
    for (var i = 0; i < addInstructorIds.length; i++) {
      var id = addInstructorIds[i];
      var listItem = favInstructorsList.querySelector("[data-instructor-id='" + id + "']");
      var modalItem = allInstructorsList.querySelector("[data-instructor-id='" + id + "']");
      var heartButton = modalItem.querySelector('.pref__favorite__heart');

      heartButton.classList.remove('pref__favorite__heart--faved');
      favInstructorsList.removeChild(listItem);
    }

    // reset the addInstructors array to empty
    addInstructorIds = [];
  }

  /**
   * resetStudios resets the checked inputs that were set on load
   * @returns {void}
   */
  function resetStudios() {
    if (originalPrimaryStudio) {
      var id = originalPrimaryStudio.id;
      var checked = originalPrimaryStudio.checked;

      var input = primarySelectContainer.querySelector('#' + id);
      input.checked = checked;
      selectedPrimary = originalPrimaryStudio;
    }

    for (var i = 0; i < originalSelectedFavorites.length; i++) {
      originalSelectedFavorites[i].checked = true;
    }

    updatePrimaryStudio();
    updateSelectedFavorites();
  }

  /**
   * closeAndSaveModal closes the modal and both removes and adds favorite instructor nodes
   * to/from the dom in the main preferences display
   * @returns {void}
   */
  function closeAndSaveModal() {
    modal.style.display = '';
    instructorsModal.classList.remove('pref__instructors__modal--active');
    deleteAccountModal.classList.remove('modal__delete-container--active');
    instructorsModal.setAttribute('data-active-modal', 'false');
    deleteAccountModal.setAttribute('data-active-modal', 'false');

    // after hiding the modal insert/remove any instructors from the fav list
    if (activeModal === 'instructors') {
      removeFavNodes();
      insertFavInstructor();

      // the data-index attributes may be out of order...reset them
      // e.g if data-index "2,4,6" were deleted, we're left with list elements that
      // have "1,3,5".  reset these to be in order "1,2,3"
      reorderDataIndex();

      // reset the modal, in case a user performed a search
      resetSearch();

      // Focus on the Save button if there is one
      if (saveButtons.length) {
        saveButtons[saveButtons.length - 1].focus();
      }
    } else if (activeModal === 'delete') {
      deleteAccountButton.focus();
    }

    isModalActive = false;
    activeModal = '';
  }

  /**
   * handleDocument click routes to the appropriate function depending on what is active.
   * if a modal is active it calls closeModalOutside, if a dropdown is active itcalls closeDropDownOutside
   *
   * @param {object} e click or keydown event
   * @returns {void}
   */
  function handleDocumentClick(e) {
    e.stopPropagation();

    if (isModalActive) {
      closeModalOutside(e);
      return;
    }

    if (activeDropDown) {
      closeDropDownOutside(e);
    }
  }

  /**
   * closeDropDownOutside allows us to close & save dropdown selections via either escape, or a click
   * outside the dropdown.
   *
   * @param {object} e click or keydown event
   * @returns {void}
   */
  function closeDropDownOutside(e) {
    e.stopPropagation();

    switch (e.type) {
    case 'keydown' :
      if (e.key === 'Escape') {
        activeDropDown.classList.remove('pref__dropdown__select--open');
        updateSelectedFavorites();
        updatePrimaryStudio();
      }
      break;
    case 'click' :
      if (!activeDropDown.contains(e.target)) {
        activeDropDown.classList.remove('pref__dropdown__select--open');
        updateSelectedFavorites();
        updatePrimaryStudio();
      }
      break;
    // No Default
    }
  }

  /**
   * closeModalOutside handles closing the Modal on clicking outside the modal or by
   * hitting escape
   *
   * @param {object} e event which triggered this function (click/keydown)
   * @returns {void}
   */
  function closeModalOutside(e) {
    e.stopPropagation();
    // act only if the modal is active
    if (!isModalActive) {
      return;
    }

    // Act on either click or escape
    // If click allow only clicks outside the modal
    switch (e.type) {
    case 'keydown' :
      if (e.key === 'Escape') {
        closeAndSaveModal();
      }
      break;
    case 'click' :
      var container = document.querySelector("[data-active-modal='true']");
      var innerContainer = container.children[0];
      if (!innerContainer.contains(e.target) || e.target.classList.contains('modal__delete__cancel', 'modal__delete__submit')) {
        closeAndSaveModal();
      }
      break;
    // No Default
    }
  }

  /**
   * showModal sets the display style to block on the instructors modal
   *
   * @param {object} e click event that triggers showing the modal
   * @returns {void}
   */
  function showModal(e) {
    e.preventDefault();
    e.stopPropagation();

    // setup display and focus
    modal.style.display = 'block';
    modal.focus();

    switch (e.target.id) {
    case 'handle-preferences-delete':
      deleteAccountModal.classList.add('modal__delete-container--active');
      deleteAccountModal.setAttribute('data-active-modal', 'true');
      activeModal = 'delete';
      break;
    default:
      instructorsModal.classList.add('pref__instructors__modal--active');
      instructorsModal.setAttribute('data-active-modal', 'true');
      activeModal = 'instructors';
      searchInstructors.focus();
      break;
    }

    isModalActive = true;
  }

  /**
   * handleEdit adds the edit-mode class to the preferences container
   *
   * @param {object} e click event
   * @returns {void}
   */
  function handleEdit(e) {
    e.preventDefault();

    preferencesContainer.classList.add('edit-mode');
  }

  /**
   * saveEdits saves all the data that was acted on
   *
   * @param {object} e click event
   * @returns {void}
   */
  function saveEdits(e) {
    e.preventDefault();

    preferencesContainer.classList.remove('edit-mode');

    // udpate the favorite studios
    updateFavoriteStudios();

    // reorder the data-index for instructors
    reorderDataIndex();

    // update all the data with the ajax call
    updateData();
  }

  /**
   * removeFavInstructor gets the id of the current the favorite instructor whose 'x' button was
   * clicked on and adds it to the remove instructor array
   *
   * @param {object} e the click event that triggered the function
   * @returns {void}
   */
  function removeFavInstructor(e) {
    e.preventDefault();
    e.stopPropagation();

    var currentTarget = e.currentTarget;
    var instructor = currentTarget.parentNode.parentNode;
    var listItem = instructor.parentNode.parentNode;
    var instructorId = listItem.getAttribute('data-instructor-id');

    removeInstructorIds.push(instructorId);

    removeFavNodes();
  }

  /**
   * removeFavnodes removes instructor nodes that were added to the removeInstructorIds array
   * from the main favorites display
   * @returns {void}
   */
  function removeFavNodes() {
    for (var i = 0; i < removeInstructorIds.length; i++) {
      var instructorId = removeInstructorIds[i];
      var node = favInstructorsList.querySelector("[data-instructor-id='" + instructorId + "']");
      var modalNode = allInstructorsList.querySelector("[data-instructor-id='" + instructorId + "']");

      if (node) {
        removeInstructorNodes.push(node);
        // eslint-disable-next-line no-loop-func
        addInstructorIds = addInstructorIds.filter(function (v) {
          return v !== instructorId;
        });
        favInstructorsList.removeChild(node);
      }

      if (modalNode) {
        var button = modalNode.querySelector('.pref__favorites__item__link');
        var heartButton = modalNode.querySelector('.pref__favorite__heart');
        var nickname = modalNode.getAttribute('data-nickname');
        button.setAttribute('aria-selected', false);
        button.setAttribute('aria-label', 'Select ' + nickname + ' as a favorite');
        heartButton.classList.remove('pref__favorite__heart--faved');
      }
    }
  }

  /**
   * updateData hits an ajax route to add/delete data for each user
   * @returns {void}
   */
  function updateData() {
    $.ajax({
      url: '/profile/instructor/favorite/',
      method: 'POST',
      dataType: 'json',
      data: {
        removeInstructors: removeInstructorIds,
        addInstructors: addInstructorIds,
        csrf_token: window.soulcycle.noncePool.pop(),
        primaryStudio: primaryStudio,
        addFavStudios: addFavStudios,
        removeFavStudios: removeFavStudios
      }
    }).done(function () {
      var studiosTooltip = document.getElementById('pref-studios-tooltip');
      var instructorTooltip = document.getElementById('pref-instructors-tooltip');
      var instructorEmptyStateContainer = document.getElementById('instructors-empty-state');
      var primaryEmptyStateContainer = document.getElementById('primary-empty-state');
      var favoriteSelectDisplay = document.getElementById('favorite-selected-container');

      // if we have favorite studios or if we have a primary studio id remove the tooltip for the studios
      // and hid the pemty state container for primary studios
      if (primaryStudio.type === 'insert') {
        // hide the primary emtpy state container
        primaryEmptyStateContainer.classList.add('pref__primary__state-container--hidden');
        // show the tootltip for studios
        studiosTooltip.classList.remove('pref__tooltip-container--hidden');
      } else {
        primaryEmptyStateContainer.classList.remove('pref__primary__state-container--hidden');
        studiosTooltip.classList.add('pref__tooltip-container--hidden');
      }

      // if we have original fav studios
      if (addFavStudios.length) {
        favoriteSelectDisplay.classList.remove('favorite__selected-container--hidden', 'pref__favoritestudios__container--hidden');
      } else {
        favoriteSelectDisplay.classList.add('favorite__selected-container--hidden');
      }

      // if the favoriteinstructors list is empty show the main instructor tooltip
      // and show the empty state container
      if (favInstructorsList.children.length <= 1) {
        instructorTooltip.classList.add('pref__tooltip-container--hidden');
        instructorEmptyStateContainer.classList.remove('pref__instructors__state-container--hidden');
      } else {
        instructorTooltip.classList.remove('pref__tooltip-container--hidden');
        instructorEmptyStateContainer.classList.add('pref__instructors__state-container--hidden');
      }
    }).done(function () {
      // reset all arrays
      addInstructorIds = [];
      removeInstructorIds = [];
      removeInstructorNodes = [];
      removeFavStudios = [];
      primaryStudio = {};

      confirmation(null, 'Your preferences have been saved.');
    }).fail(function (xhr) {
      confirmation(null, 'Oops! An error occurred while submitting your request. Try that again!');
      console.log('Post error: ', xhr);
    });
  }

  /**
   * handleModalInstructors determines whether to fav or unfav an instructor and routes it to the appropriate array.
   * @param {object} e click event triggered by clicking on the heart buttons
   * @returns {void}
   */
  function handleModalInstructors(e) {
    e.preventDefault();
    e.stopPropagation();

    var currentTarget = e.currentTarget;
    var button = currentTarget.parentNode;
    var listItem = button.parentNode.parentNode;
    var heart = currentTarget.querySelector('.pref__favorite__heart');
    var nickname = listItem.getAttribute('data-nickname');
    var instructorId = listItem.getAttribute('data-instructor-id');

    // if the current button has a faved heart, we want to remove from the favs
    // and push the ids into the remove ids array
    if (heart.classList.contains('pref__favorite__heart--faved')) {
      heart.classList.remove('pref__favorite__heart--faved');
      button.setAttribute('aria-selected', false);
      button.setAttribute('aria-label', 'Select ' + nickname + ' as a favorite');
      // if this was a case of a toggle, ie clicking/unclicking the heart button, make
      // sure we remove it from the addInstructors
      addInstructorIds = addInstructorIds.filter(function (v) {
        return v !== instructorId;
      });
      removeInstructorIds.push(instructorId);
      return;
    }

    // get rid of this from the removeInstructorIds if this was a toggle.
    removeInstructorIds = removeInstructorIds.filter(function (v) {
      return v !== instructorId;
    });

    // all logic to add to the favs, first set the class
    heart.classList.add('pref__favorite__heart--faved');
    button.setAttribute('aria-selected', true);
    button.setAttribute('aria-label', 'Remove ' + nickname + ' as a favorite');

    // push to the array of ids to add
    addInstructorIds.push(instructorId);
  }

  /**
   * insertFavInstructors handles inserting the instructor list item from the modal
   * into the main tab.  it sets a new data-index on the cloned node and swaps classes
   * @returns {void}
   */
  function insertFavInstructor() {
    for (var i = 0; i < addInstructorIds.length; i++) {
      var id = addInstructorIds[i];
      var instructor = allInstructorsList.querySelector("[data-instructor-id='" + id + "']");
      var isAlreadyFav = favInstructorsList.querySelector("[data-instructor-id='" + id + "']");

      // do nothing if this instructor already exists in the fav list
      if (isAlreadyFav) {
        continue;
      }

      var node = instructor.cloneNode(true);
      var link = node.querySelector('.pref__favorites__item__link');
      var listItems = favInstructorsList.children.length;
      var heartButton = node.querySelector('.pref__favorite__heart');

      // data-index is zero based, but we have an additional item at the end of the list.
      // the index we need is then the total of listitems - 1
      // e.g. if we have 3 instructors the total of listitems will be 4. (3 + 'add instructor')
      // adding an instructor will correctly give a data-index=3
      var index = listItems - 1;

      // the attributes that were used for accessibility on the modal are no longer
      // necessary since the main image is used as a link.
      link.removeAttribute('role');
      link.removeAttribute('aria-selected');
      link.removeAttribute('aria-label');

      // udpate the data-index attribute and swap classes.
      node.setAttribute('data-index', index);
      node.classList.remove('pref__instructor__item');
      node.classList.add('pref__favorites__item');

      // remove the heart from this node.
      node.remove(heartButton);
      // ensure there's no inline display on this node
      node.style.display = '';

      // inject this before the last element in the list
      favInstructorsList.insertBefore(node, favInstructorsList.children[index]);

      // because this is a cloned element we need to reattach event listeners.
      var button = node.querySelector('.pref__favorite__remove-button');

      button.setAttribute('aria-hidden', false);
      button.addEventListener('click', removeFavInstructor);
    }
  }

  /**
   * reorderDataIndex reorders each favorite items data-index in order
   * @returns {void}
   */
  function reorderDataIndex() {
    var favInstructors = favInstructorsList.children;

    for (var i = 0; i < favInstructors.length; i++) {
      var listItem = favInstructors[i];
      listItem.setAttribute('data-index', i);
    }
  }

  /**
   * filterInstructors performs a keypress search in the instructors modal
   * by matching each keys pressed to an instructor name
   * e.g 'sa' would return 'sam, samantha, sally, salmon' etc.
   * @param {object} e keyup event triggered by typing in the search bar
   * @returns {void}
   */
  function filterInstructors(e) {
    var searchTerm = e.currentTarget.value.toLowerCase();
    // eslint-disable-next-line no-unused-vars
    var totalResults = 0;

    for (var i = 0; i < allInstructors.length; i++) {
      var instructor = allInstructors[i];
      var nickname = instructor.getAttribute('data-nickname').toLowerCase();
      var result = nickname.substring(0, searchTerm.length);

      if (result === searchTerm) {
        instructor.style.display = 'block';
        totalResults++;
      } else {
        allInstructors[i].style.display = 'none';
      }
    }
  }

  /**
   * resetSearch undoes any styling issues set by a user performing a search
   * @returns {void}
   */
  function resetSearch() {
    searchInstructors.value = '';
    for (var i = 0; i < allInstructors.length; i++) {
      allInstructors[i].style.display = 'block';
    }
  }

  /**
   * handleFavInstructorClick hijacks the click event when in edit mode
   * @param {object} e click event on favorite instructor
   * @returns {void}
   */
  function handleFavInstructorClick(e) {
    // do nothign if this is the plus sign ('add-instructor-handler')
    // or if the modal is active
    if (e.currentTarget.id === 'add-instructor-handler' || isModalActive) {
      return;
    }

    // if we're in edit mode disable the click on the instructor and make it
    // behave like the delete button
    if (preferencesContainer.classList.contains('edit-mode')) {
      e.preventDefault();
      removeFavInstructor(e);
    }
  }

  /**
   * closeFavoriteStudioDropDown closes the favorites studio dropdown
   * and updates the selected studios displayed.
   * @returns {void}
   */
  function closeFavoriteStudioDropDown() {
    favoriteSelectContainer.classList.remove('pref__dropdown__select--open');
    updateSelectedFavorites();
  }

  /**
   * updateSeelectedFavorites gets the currently checked input boxes in the favorites dropdown
   * and begins to build the visually active buttons beneath the dropdown.  (grey boxes with x icon)
   * @returns {void}
   */
  function updateSelectedFavorites() {
    selectedFavorites = document.querySelectorAll('.pref__dropdown__favorites__input:checked');
    var selectedContainer = document.querySelector('.favorite__studios__selected-container');

    if (!selectedContainer) {
      return;
    }

    selectedContainer.innerHTML = '';

    for (var i = 0; i < selectedFavorites.length; i++) {
      var id = selectedFavorites[i].id;
      var name = selectedFavorites[i].getAttribute('data-name');

      var div = document.createElement('div');
      var text = document.createElement('div');
      var button = document.createElement('button');
      var img = document.createElement('img');

      div.className = 'favorite__studios__selected';
      div.setAttribute('data-studio-id', id);
      text.className = 'favorite__studios__selected__text';
      text.innerHTML = name;
      button.className = 'favorite__studios__selected__button';
      button.tabIndex = 0;
      img.className = 'favorite__studios__selected__delete';
      img.src = '/assets/images/profile/delete.svg';
      img.alt = 'Remove this studio';

      button.appendChild(img);
      div.appendChild(text);
      div.appendChild(button);

      button.addEventListener('click', uncheckStudio);

      selectedContainer.appendChild(div);
    }

    counterElement.innerHTML = selectedFavorites.length;
  }

  /**
   * closePrimaryStudioDropDown simply closes the primary studio dropdown
   * no saving is necessary since we have to query for a checked box again
   * before we make the ajax call to save our data.
   * @returns {void}
   */
  function closePrimaryStudioDropDown() {
    primarySelectContainer.classList.remove('pref__dropdown__select--open');
    updatePrimaryStudio();
  }

  /**
   * updatePrimaryStudio  sets the selected primary studio as text, enables the favorite studios dropdown
   * and sets the emtpy state container to hidden;
   * @returns {void}
   */
  function updatePrimaryStudio() {
    var placeHolder = null;
    var selectedText = null;

    if (selectedPrimary) {
      primaryStudio.id =  selectedPrimary.value;
      primaryStudio.type = 'insert';

      // update both the placeholder for the dropdown and the actual selected value
      placeHolder = document.getElementById('pref-dropdown-primary-placeholder');
      selectedText = document.getElementById('primary-selected-studio');
      placeHolder.innerHTML = selectedPrimary.getAttribute('data-name');
      selectedText.innerHTML = selectedPrimary.getAttribute('data-name');

      // set the selected container visible
      var selectedContainer = document.getElementById('primary-selected-container');
      selectedContainer.classList.remove('primary__selected-container--hidden');

      // enable the favorite studios dropdown
      var favoriteStudiosContainer = document.querySelector('.pref__favoritestudios__container');
      favoriteStudiosContainer.classList.remove('pref__favoritestudios__container--hidden');

      // remove the initial empty state container.  this will exist only on a first
      // setup. once the primary studio is set, we only allow a reset but not a remove so this
      // will never change.
      var emptyStateContainer = document.querySelector('.primary__empty__state-container');
      if (emptyStateContainer) {
        emptyStateContainer.style.display = 'none';
      }
    } else {
      selectedContainer = document.getElementById('primary-selected-container');
      selectedContainer.classList.add('primary__selected-container--hidden');
    }
  }

  /**
   * clearPrimaryStudioSelection clears any checkbox that was checked for the primary studios
   * @returns {void}
   */
  function clearPrimaryStudioSelection() {
    var placeHolder = document.getElementById('pref-dropdown-primary-placeholder');

    if (selectedPrimary) {
      primaryStudio.id =  selectedPrimary.value;
      // Remove primary studio from favorites, too.
      removeFavStudios.push(primaryStudio.id);
      selectedPrimary.checked = false;
      primaryStudio.type = 'unset';
      var selectedContainer = document.getElementById('primary-selected-container');

      selectedContainer.classList.add('primary__selected-container--hidden');
      selectedPrimary = null;
    }

    placeHolder.innerHTML = 'Select One';
  }

  /**
   * clearFavoriteStudioSelection clears any checkbox that was checked for the favorite studios
   * @returns {void}
   */
  function clearFavoriteStudioSelection() {
    selectedFavorites = document.querySelectorAll('.pref__dropdown__favorites__input:checked');
    var selectedContainer = document.querySelector('.favorite__studios__selected-container');

    for (var i = 0; i < selectedFavorites.length; i++ ) {
      selectedFavorites[i].checked = false;
      removeFavStudios.push(selectedFavorites[i].value);
    }

    // reset arrays container, and counter
    addFavStudios = [];
    selectedContainer.innerHTML = '';
    counterElement.innerHTML = 0;
  }

  /**
   * handleFavoriteStudioInputs keeps track of the count of studios a user has favorited
   *
   * @param {object} e the change event triggering this function from a checkbox
   * @returns {void}
   */
  function handleFavoriteStudioInputs(e) {
    var counter = parseInt(counterElement.innerHTML, 10);
    var target = e.target;

    if (target.checked) {
      addFavStudios.push(target.value);
      removeFavStudios = removeFavStudios.filter(function (v) {
        return v !== target.value;
      });
      counter++;
    } else {
      removeFavStudios.push(target.value);
      addFavStudios = addFavStudios.filter(function (v) {
        return v !== target.value;
      });
      counter--;
    }

    counterElement.innerHTML = counter;
  }

  /**
   * toggleDropDown handles toggling the appropriate dropdown based on the
   * event data passed in
   *
   * @param {object} e the click event that triggered the dropdown toggles
   * @returns {void}
   */
  function toggleDropDown(e) {
    e.stopPropagation();

    var target = e.currentTarget;
    var dropDown = target.nextElementSibling;
    var openDropDown = document.querySelector('.pref__dropdown__select--open');

    if (!openDropDown) {
      dropDown.classList.add('pref__dropdown__select--open');
      activeDropDown = dropDown;
    } else if (openDropDown === dropDown) {
      dropDown.classList.remove('pref__dropdown__select--open');
      activeDropDown = null;
    } else {
      openDropDown.classList.remove('pref__dropdown__select--open');
      dropDown.classList.add('pref__dropdown__select--open');
      activeDropDown = dropDown;
    }

    updateSelectedFavorites();
    updatePrimaryStudio();
  }

  /**
   * uncheckStudio forces a change event to occur by firing off a programmatic click
   * on the favorit inputs
   * @param {object} e click event
   * @returns {void}
   */
  function uncheckStudio(e) {
    var target = e.currentTarget;
    var id = target.parentNode.getAttribute('data-studio-id');
    var input = favoriteSelectContainer.querySelector('#' + id);

    // fire off a click which will force the change handler to run
    input.click();
    target.parentNode.remove(target);
  }

  /**
   * updateFavoriteStudios builds out the favorite studio buttons below the favorite dropdown.
   * @returns {void}
   */
  function updateFavoriteStudios() {
    selectedFavorites = document.getElementById('favorite-selected-studio');
    selectedFavorites.innerHTML = '';

    for (var i = 0; i < addFavStudios.length; i++) {
      var id = addFavStudios[i];
      var input = favoriteSelectContainer.querySelector('#fav-' + id);
      var name = input.getAttribute('data-name');

      var li = document.createElement('li');
      li.className = 'favorite__selected__studio-item';
      li.innerHTML = name;

      selectedFavorites.appendChild(li);
    }
  }

  init();

  return {
    init: function () {
      // Initialize this manually when we load in via ajax
      // first load the lazies
      SC.loadLazyImages();
      // run the initialization
      init();
    }
  };
})();
